// store/preloadConfig.js

import {getExpenseCategoryList} from "@/api/managementMenu/expenseCategory";

import {getDosaUnt, getMedcas, getMedicationFrequency, getMedicationWay} from "@/api/MedicenCata";
import {yglist} from "@/api/staff/staff";
import {docclinicList, getDeptName} from "@/api/ks/ks";
import {getChargingPrice} from "@/api/cosrute/Cosrute";
import {getDoctorList} from "@/api/scheduling/scheduling";
import {getAttribute, getCategory, getStaffList} from "@/api/clinicSchedule/clinicSchedule";
import {pinyin} from "pinyin-pro";
import {getContuntList, getDocphrList} from "@/api/reservation/reservation";
import {getSystemList} from "@/api/systemParameter/systemParameter";
import {getAllDept, getRegisterType} from "@/api/reservation/reservationList";
import {selectDrugDosageForm} from "@/api/systemCatalogue/Pharmacological";
import {getAiseList, getDrugUnt} from "@/api/reservation/outpatientPhysician";
import {getFinancialSummaryAccountList} from "@/api/financialSummaryManagement/financialSummaryAccount";
import {selectDropDownList} from "@/api/systemCatalogue/Western";

export default {
    // 费用类别
    getCostTypeOptions: {
        api: getExpenseCategoryList,  // API方法
        formatter: (item) => ({       // 数据格式化规则
            id: item.id,
            label: item.name,
            applyobject: item.applyobject
        })
    },

    // 财务科目
    getFinancialOptions: {
        api: getFinancialSummaryAccountList,
        formatter: (item) => ({
            id: item.id,
            label: item.name,
            code: item.code,
            costtypeList: item.costtypeList,
        })
    },


    // 病案费别
    getMedicalRecordCostOptions: {
        api: getMedcas,
        formatter: (item) => ({
            id: item.id,
            label: item.name
        })
    },

    // 员工列表
    getEmployeeOptions: {
        api: yglist,
        formatter: (item) => ({
            id: item.id,
            label: item.fullName
        })
    },

    // 科室专业列表
    getDepartmentSpecialtyOptions: {
        api: getDeptName,
        formatter: (item) => ({
            id: item.id,
            label: item.name
        })
    },

    // 科室专业列表
    getClinicListOptions: {
        api: docclinicList,
        formatter: (item) => ({
            id: item.id,
            label: item.name
        })
    },

    //项目价格列表
    getChargingPriceOptions: {
        api: getChargingPrice,
        formatter: (item) => ({
            id: item.id,
            label: item.costname,
            odcost: item.odcost,
            executedepid: item.executedepid,
            depexecutetype: item.depexecutetype,
            executemode: item.executemode,
            costmode: item.costmode,
            type:item.type
        })
    },

    //医生列表
    getDoctorListOptions: {
        api: getDoctorList,
        formatter: (item) => ({
            id: item.id, label: item.fullName, titel: item.professionalTitle
        })
    },

    //挂号类别列表
    getCategoryOptions: {
        api: getCategory,
        formatter: (item) => ({
            id: item.id,
            label: item.designation,
            odcost: Number(item.odcost).toFixed(2),
            pycode: pinyin(item.designation, {pattern: 'first', toneType: 'none', separator: ''}).toLocaleUpperCase(),
        })
    },

    //医生列表
    getAttributeListOptions: {
        api: getAttribute,
        formatter: (item) => ({
            id: item.id,
            label: item.deptName,
            specialtyName: item.specialtyName,
            specialtyCode: item.specialtyCode
        })
    },

    //员工列表
    getStaffListOptions: {
        api: getStaffList,
        formatter: (item) => ({
            id: item.id,
            label: item.fullName,
        })
    },

    //往来单位
    getContuntListOptions: {
        api: getContuntList,
        formatter: (item) => ({
            id: item.id, label: item.name, code: item.code
        })
    },

    //健康档案
    getDocphrListOptions: {
        api: getDocphrList,
        formatter: (item) => ({
            id: item.id, certno: item.certno, label: item.name
        })
    },

    //系统参数
    getSystemListOptions: {
        api: getSystemList,
        formatter: (item) => ({
            ...item
        })
    },

    //科室列表
    getDeptListOptions: {
        api: (params) => getAllDept(params),
        formatter: (item) => ({
            id: item.id,
            label: item.deptName,
            specialtyName: item.specialtyName,
            specialtyCode: item.specialtyCode
        }),
    },

    //挂号类别
    getRegisterTypeListOptions: {
        api: getRegisterType,
        formatter: (item) => ({
            label: item.designation, id: item.id
        })
    },

    //科室列表
    getAllDeptListOptions: {
        api: getAllDept,
        formatter: (item) => ({
            id: item.id, label: item.deptName
        })
    },

    //过敏原
    getAiseListOptions: {
        api: getAiseList,
        formatter: (item) => ({
            label: item.name, id: item.id, orderId: item.orderId
        })
    },

    //给药
    getMedicationWayListOptions: {
        api: getMedicationWay,
        formatter: (item) => ({
            id: item.id, label: item.name, frquCnt: item.frquCnt, frquPrd: item.frquPrd
        })
    },

    getDrugDosageListOption: {
        api: selectDrugDosageForm,
        formatter: (item) => ({
            id: item.id, label: item.dosageName
        })
    },

    getDosaUntListOption: {
        api: getDosaUnt,
        formatter: (item) => ({
            id: item.id, label: item.name
        })
    },

    //单位
    getDrugUntListOption: {
        api: getDrugUnt,
        formatter: (item) => ({
            id: item.id, label: item.name
        })
    },

    //包装单位
    getDrugUntOptions: {
        api: getRegisterType,
        formatter: (item) => ({
            id: item.id, label: item.name
        })
    },

    //给药方式
    getMedicationFrequencyOptions: {
        api: getMedicationFrequency,
        formatter: (item) => ({
            id: item.id, label: item.name
        })
    },

    // 后续新增的预加载接口在这里添加...
}